import { createAsyncThunk } from "@reduxjs/toolkit";
import { STATION_AMENITIES } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const addAndEditStationAminityAPI: any = createAsyncThunk(
  "addAndEditStationAminity",
  async ({ formData, method, id }: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios({
        method: method,
        url: !!id ? STATION_AMENITIES + id : STATION_AMENITIES,
        data: formData,
        headers: commonHead,
      });

      return res;
    } catch (error: any) {
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
